import React from "react";

/**
 * Loading spinner component
 */
export const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center flex-col">
    <div className="animate-spin w-8 h-8 border-4 border-primary border-t-transparent rounded-full" />
    <h2 className="text-xl font-semibold mt-2">Loading...</h2>
  </div>
);
